import dayjs from 'dayjs';
import { call, fork, put, select, take } from 'redux-saga/effects';
import { getJSON } from '../../shared/util';

export function* fetch(date) {
    const user = yield select(state => state.user);
    const url = '/api/of-the-day/hexagram';
    let hexagrams = {};
    let response;
    let args = {
        date: date || dayjs().format('YYYY-MM-DD'),
    };

    try {
        response = yield call(getJSON, url, args);
        hexagrams.everyone = response.data;
    } catch (e) {
        return;
    }

    if (user && user.logged_in && user.birth_date) {
        args.birthdate = user.birth_date;

        try {
            response = yield call(getJSON, url, args);
            hexagrams.you = response.data;
        } catch (e) {
            return;
        }
    }

    yield put({ type: 'hexagram:update', payload: hexagrams });
}

export function* root() {
    const action = yield take('hexagram:require');

    yield fork(fetch, action.payload);

    while (true) {
        let action = yield take('user:logged-in');
        yield fork(fetch, action.payload);
    }
}
